// import { intervalToDuration } from "date-fns";
import React, { useEffect, useState } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { listPatients, registerPatient } from "../actions/patientActions";
import { notify } from "./notify";
import Message from "./Message";
import { PATIENT_REGISTER_RESET } from "../constants/patientConstants";
import { Howl } from "howler";
import Loader from "./Loader";
import SimpleToast from "./SimpleToast";
import { MdAddIcCall, MdHelpOutline } from "react-icons/md";
import PatientPhone from "./PatientPhone";
import { IoReload } from "react-icons/io5";
import { IoPersonAddOutline } from "react-icons/io5";

const PatientRegister = ({ clinicOwnerId, pageNumber, clinicId }) => {
  const [firstName, setFirstName] = useState("");
  const [secondName, setSecondName] = useState("");
  const [thirdName, setThirdName] = useState("");
  const [fourthName, setFourthName] = useState("");
  const [birthdate, setBirthdate] = useState("");
  const [phones, setPhones] = useState([{ _id: Math.random(), phone: "" }]);
  const [refresh, setRefresh] = useState(false);

  const patientListStore = useSelector((state) => state.patientListStore);
  const { noRequest, patients } = patientListStore;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const patientAdditionStore = useSelector(
    (state) => state.patientAdditionStore,
  );
  const { patientInfo, error, loading } = patientAdditionStore;

  const deletePhone = (p) => {
    if (window.confirm("are you sure?")) {
      setPhones(phones.filter((ph) => ph._id !== p._id));
    }
  };

  const dispatch = useDispatch();

  const submitHandler = (e) => {
    e.preventDefault();
    if (!firstName && !secondName && !thirdName && !fourthName && !birthdate) {
      notify({
        title: "Registration Err",
        message: <p className="lead">Kindly, type patient details first.</p>,
        type: "danger",
        duration: 3000,
      });
    } else {
      if (patients && patients.length > 0) {
        notify({
          title: "Registration Err",
          message: (
            <p className="lead">
              You already had a patient with such data.
              <br /> Click on him below 👇👇
            </p>
          ),
          type: "danger",
          duration: 3000,
        });
      } else {
        if (
          !firstName ||
          !secondName ||
          !thirdName ||
          !fourthName ||
          !birthdate
        ) {
          notify({
            title: "Registration Err",
            message: (
              <p className="lead">
                Kindly, compelete the data
                <br />
                All cells are required 😎😎
              </p>
            ),
            type: "danger",
            duration: 3000,
          });
        } else {
          dispatch(
            registerPatient({
              firstName,
              secondName,
              thirdName,
              fourthName,
              birthdate,
              clinicId,
              clinicOwnerId,
              secretaryId: userInfo._id,
              phones: phones.map((p) => {
                return {
                  phone: p.phone,
                };
              }),
            }),
          );
        }
      }
    }
  };

  const clearForm = () => {
    setFirstName("");
    setSecondName("");
    setThirdName("");
    setFourthName("");
    setBirthdate("");
  };
  // to jumb instead of typing space
  const goNext = (e) => {
    const form = e.target.form;
    const index = Array.prototype.indexOf.call(form, e.target);
    form.elements[index + 1] && form.elements[index + 1].focus();
  };
  const onKeyDownSpace = (e) => {
    if (e.key === " ") {
      e.preventDefault();
      goNext(e);
    }
  };
  const onInputSpace = (e) => {
    const v = e.target.value;
    if (v.endsWith(" ")) {
      e.target.value = v.trim();
      goNext(e);
    }
  };

  useEffect(() => {
    if (patientInfo) {
      notify({
        title: "Registration Success",
        message: (
          <p className="lead">
            The patient is added Successfully
            <br /> Click on him below 👇👇
          </p>
        ),
        type: "success",
        duration: 3000,
      });
      var sound = new Howl({
        src: `/success.mp3`,
      });
      sound.play();
      dispatch({ type: PATIENT_REGISTER_RESET });
    }
    dispatch(
      listPatients({
        firstName,
        secondName,
        thirdName,
        fourthName,
        birthdate,
        clinicOwnerId,
        pageNumber,
        clinicId,
        phones: phones.filter((p) => p.phone !== "").map((p) => `${p.phone}-`),
      }),
    );
  }, [
    dispatch,
    patientInfo,
    firstName,
    secondName,
    thirdName,
    fourthName,
    birthdate,
    clinicOwnerId,
    clinicId,
    pageNumber,
    noRequest,
    phones,
    refresh,
  ]);

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <Form onSubmit={submitHandler}>
          <SimpleToast
            cell={
              <h2>
                {`Search by Patient Details and Add him if missed.`}
                <MdHelpOutline className="text-xl text-gray-500 cursor-pointer relative -top-1" />
              </h2>
            }
            title="كيف أضيف عميل جديد؟ وأين أبحث عنه؟"
            body="يمكنك إضافة البيانات من هنا، وسيبحث البرنامج في سجلات المرضى عن بيانات مشابهة بمجرد إضافة أي حرف، ويمكنك رؤية النتائج في الأسفل👇، فإذا لم يجدها فلن تحتاج لكتابة البيانات من جديد، يمكنك الإضافة فوراً إذا اكتملت البيانات"
          />

          <Row className="justify-content-center pb-2">اسم المريض رباعي</Row>
          <Row className="flex-row-reverse">
            <Form.Group controlId="firstName" className="col-sm-3">
              <Form.Control
                className="text-center"
                type="text"
                placeholder="اسم المريض"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                onKeyDown={onKeyDownSpace}
                onInput={onInputSpace}
                isValid={firstName}
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId="secondName" className="col-sm-3">
              <Form.Control
                type="text"
                className="text-center"
                placeholder="اسم الأب"
                value={secondName}
                onChange={(e) => setSecondName(e.target.value)}
                onKeyDown={onKeyDownSpace}
                onInput={onInputSpace}
                isValid={secondName}
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId="thirdName" className="col-sm-3">
              <Form.Control
                type="text"
                className="text-center"
                placeholder="اسم الجد"
                value={thirdName}
                onChange={(e) => setThirdName(e.target.value)}
                onKeyDown={onKeyDownSpace}
                onInput={onInputSpace}
                isValid={thirdName}
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId="fourthName" className="col-sm-3">
              <Form.Control
                type="text"
                className="text-center"
                placeholder="الاسم الرابع"
                value={fourthName}
                onChange={(e) => setFourthName(e.target.value)}
                onKeyDown={onKeyDownSpace}
                onInput={onInputSpace}
                isValid={fourthName}
              ></Form.Control>
            </Form.Group>
          </Row>

          <Row>
            <Col>
              <Form.Group controlId="birthdate">
                <Row className="form-label justify-content-center pb-2">
                  تاريخ الميلاد
                </Row>
                <Form.Control
                  type="date"
                  className="text-center"
                  placeholder="Enter Birthdate"
                  value={birthdate}
                  onChange={(e) => setBirthdate(e.target.value)}
                  isValid={birthdate}
                ></Form.Control>
              </Form.Group>
            </Col>
          </Row>

          <section id="phone">
            <Row className="form-label justify-content-center mr-2 pb-2">
              أرقام الهواتف
            </Row>
            {phones.map((p) => (
              <div key={p._id}>
                <PatientPhone
                  phoneObj={p}
                  deletePhone={deletePhone}
                  refresh={refresh}
                  setRefresh={setRefresh}
                />
              </div>
            ))}
            <Row className="justify-content-center mb-2">
              <Col
                xs="auto" // Ensures the column's width is only as wide as its content
                className="text-center" // Centers the content inside the column
                onClick={() =>
                  setPhones([...phones, { _id: Math.random(4), phone: "" }])
                }
              >
                إضافة رقم <MdAddIcCall />
              </Col>
            </Row>
          </section>

          {error && (
            <Message
              children={`Patient Reigister Err: ${error}`}
              variant={`danger`}
            />
          )}

          <Row>
            <Col>
              <Button variant="outline-danger" onClick={() => clearForm()}>
                <IoReload /> Clear Form
              </Button>
            </Col>
            <Col className="text-right">
              <Button variant="outline-primary" type="submit">
                <IoPersonAddOutline /> Add Patient
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </div>
  );
};

export default PatientRegister;
